import {
  toValue,
  type MaybeRefOrGetter,
  type ComputedRef,
  computed,
  onMounted,
  watchEffect,
} from "vue";
import type { ApiObject } from "@/models/api";
import type { SortedObjectsWrapper } from "@/types/apiStore";
import { useApiStore } from "@/stores/api";

export type PrintValuesReturn = {
  title: ComputedRef<string | null>,
  object: ComputedRef<ApiObject | null>,
  item: ComputedRef<SortedObjectsWrapper | null>,
};

export function useObjectTitle(
  id: MaybeRefOrGetter<number | null | undefined>,
): PrintValuesReturn {
  const api = useApiStore();
  const idRef = computed(() => toValue(id));
  const item = computed<SortedObjectsWrapper | null>(() =>
    idRef.value ? api.byId(idRef.value) : null
  );
  // noinspection TypeScriptUnresolvedReference
  watchEffect(() => {
    onMounted(() => {
      // noinspection TypeScriptUnresolvedReference,TypeScriptValidateJSTypes
      if (item.value === null) {
        // noinspection TypeScriptUnresolvedReference,TypeScriptValidateJSTypes
        api.fetchObjects();
      }
    });
  });

  const object = computed<ApiObject | null>(() =>
    item.value === null ? null : item.value?.data.object
  );
  const title = computed(() =>
    item.value ? item.value.data.object.name : "Item"
  );

  return {
    item,
    object,
    title,
  };
}
